<template>
    <print-layout>

        <div class="print-container">

            <div class="text-center mb-2">
                <div class="text-2xl font-bold">{{ formatTitle(report) }} Report</div>
                <div>{{ formatDate(from) }} - {{ formatDate(to) }}</div>
            </div>

            <div class="rounded-t overflow-hidden border border-b-0">
                <!-- Report Vue Components -->
                <item-sales v-if="report === 'item_sales'" :data="data"/>
                <customer-sales v-if="report === 'customer_sales'" :data="data"/>
                <rep-sales v-if="report === 'rep_sales'" :data="data"/>

            </div>
        </div>

    </print-layout>
</template>

<script>
import PrintLayout from '@/Layouts/PrintLayout.vue';
import { DateTime } from "luxon";

// Reports
import CustomerSales from '@/Pages/Reports/Wholesale/CustomerSales';
import ItemSales from '@/Pages/Reports/Wholesale/ItemSales';
import RepSales from '@/Pages/Reports/Wholesale/RepSales';

export default {
    components: {
        PrintLayout,
        CustomerSales,
        ItemSales,
        RepSales,
    },

    props: ['report', 'from', 'to', 'data'],

    methods: {
        formatDate(date)
        {
            return DateTime.fromISO(date).toFormat('MMM d, yyyy');
        },
        formatTitle(string)
        {
            return string.split('_').map(word => word.charAt(0).toUpperCase() + word.substring(1)).join(' ');
        }
    },

    // computed: {
    //     totalItemQty() {
    //         if (this.report === 'item_sales') {
    //             return this.data.reduce(function(accumulator, currentValue){
    //                 return accumulator + Number(currentValue.total_qty);
    //             }, 0);
    //         }
    //         else return null;
    //     },
    // },

    mounted () {
        window.print();

        window.onafterprint = function() {
            window.close();
        };
    }
}

</script>

<style>
    body {
        font-size: 90%;
        height: 100%;
    }

    table {
        width: 100%;
    }

    table td {
        -webkit-print-color-adjust: exact;
    }

    .page-break {
        page-break-after: always;
    }

    @media screen {
        .print-container {
            display: none;
        }
    }

    tr:nth-child(even):not(.not_striped) {
        background-color: #f2f2f2;
    }
</style>
